export default "__VITE_ASSET__DadSO9Si__"